module.exports = __webpack_public_path__ + "img/andrew_ashley.b57ace4b.svg";